<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-welcome"
    :style="fondo"
  >
    <div class="columns is-marginless welcome-content">
      <div class="column is-half-desktop is-hidden-mobile"></div>
      <div
        class="column is-half-desktop is-half-touch black-background welcome-content"
        align="center"
      >
        <div class="column is-hidden-tablet-only" style="height: 40%"></div>
        <div class="column is-paddingless width-23p">
          <img :src="getImg('Welcome/logocalce-new.png')" alt="" />
        </div>
        <p class="is-size-1 has-font-unica white-color">FUNDAS</p>
        <a href="https://www.calce.cl/catalogo_2020">
          <button class="button button-style is-transparent">
            Catálogo
          </button>
        </a>
        <p class="white-color">
          <br>
          <b>Escribenos a contacto@calce.cl para <br />obtener la tuya!</b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from '@/utils/assets-helpers'

export default {
  name: 'Welcome',
  methods: {
    getImg
  },
  data: function() {
    return {
      fondo: `background-image: url("${getImg('Welcome/fondo-welcome.jpg')}"); background-size: cover`
    }
  }
}
</script>

<style>
.black-background {
  background: rgba(0, 0, 0, 0.8);
}

.width-23p {
  width: 23%;
}
@media screen and (max-width: 1080px) {
  .width-23p {
    width: 90%;
  }
  .black-background {
    background: rgba(0, 0, 0, 0.6);
  }
}

.welcome-content {
  height: 100vh;
}

.white-color {
  color: white;
}
</style>
